import { render, staticRenderFns } from "./StudentApplicationList.vue?vue&type=template&id=3ca3d958"
import script from "./StudentApplicationList.vue?vue&type=script&lang=js"
export * from "./StudentApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports